<div class="wrapper">
  <div class="header">
    <ng-content></ng-content>
  </div>
  <div class="body">
    <div *ngFor="let building of buildings; let i = index">
      <app-inside-survey-address-info-form
        [building]="building"
        [index]="i * buildings.length"
        [buildingIndex]="i + 1"
        [buildingKey]="building?.lomKey"
        [isAuthCanWrite]="isAuthCanWrite"
        (mainAddressUpdated)="updateMainAddress(building.id, $event)"
      ></app-inside-survey-address-info-form>
    </div>
    <div class="surveyor-name-wrap" *ngIf="onTablet">
      <mat-icon class='material-icons-outlined'> inventory </mat-icon>
      <span class="surveyor-name">{{fullName}}</span>
    </div>
  </div>
</div>
